import React, { useState } from 'react';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';

export interface DragAndZoomProps {
    children: React.ReactNode | undefined;
    maxWidth?: number;
    maxHeight?: number;
}

export default function DragAndZoom({ children, maxWidth, maxHeight }: DragAndZoomProps) {

    const [cursor, setCursor] = useState<'grab' | 'grabbing'>('grab');

    if (maxWidth && maxHeight) {
        return (
            <div
                style={{
                    cursor,
                    maxWidth,
                    maxHeight,
                    overflow: 'hidden',
                    width: '100%',
                    height: '100%',
                }}
                onMouseDown={() => setCursor('grabbing')}
                onMouseUp={() => setCursor('grab')}
                onMouseLeave={() => setCursor('grab')}
            >
                <TransformWrapper
                    initialScale={1.5}
                    minScale={0.1}
                    centerOnInit={true}
                >
                    <TransformComponent
                        wrapperStyle={{
                            maxWidth: '100%',
                            maxHeight: '100%',
                            width: '100%',
                            height: '100%',
                        }}
                    >
                        {children}
                    </TransformComponent>
                </TransformWrapper>
            </div>
        );
    } else {
        return <div style={{ cursor }} onMouseDown={() => setCursor('grabbing')} onMouseUp={() => setCursor('grab')} onMouseLeave={() => setCursor('grab')}>
            <TransformWrapper>
                <TransformComponent>
                    {children}
                </TransformComponent>
            </TransformWrapper>
        </div>;
    }

}
